<template>
  <div>
    <BaseDetailLayout title="Account Manager Details">
      <template #action>
        <PrimaryButton
          :to="`/app/admin/account_manager/edit/${viewDetail.id}`"
          name="Edit"
          icon="mdi-plus"
          iconSize="x-large"
        >
        </PrimaryButton>
      </template>
      <template #detail>
        <div style="display: grid; grid-template-columns: 450px 1fr">
          <div>
            <v-card
              :loading="loading"
              class="mx-auto my-12"
              max-width="390"
              v-if="viewDetail"
            >
              <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-center pb-2 pt-8">
                  <v-img
                    contain
                    :src="
                      viewDetail.profile_image
                        ? viewDetail.profile_image
                        : $globalConstant.profileImage
                    "
                    max-height="150"
                    max-width="150"
                    height="150"
                    width="150"
                    class="rounded-circle"
                  />
                  <input
                    name="profile_image"
                    ref="profileUpload"
                    class="d-none"
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    @change="onFileChanged($event)"
                  />
                </v-col>
              </v-row>

              <v-card-title class="d-flex justify-center">{{
                viewDetail.name
              }}</v-card-title>

              <v-divider class="mx-4"></v-divider>

              <v-card-text class="pl-4">
                <v-row no-gutters class="py-2">
                  <v-col cols="7" class="d-flex align-center">
                    <v-icon class="mr-4 primary--text" small
                      >mdi-account</v-icon
                    >
                    <h4>Name</h4>
                  </v-col>
                  <v-col
                    cols="5"
                    v-if="viewDetail.first_name || viewDetail.last_name"
                    >{{ viewDetail.first_name }}
                    {{ viewDetail.last_name }}</v-col
                  >
                </v-row>
                <v-row no-gutters class="py-2">
                  <v-col cols="7" class="d-flex align-center">
                    <v-icon class="mr-4 primary--text" small>mdi-phone</v-icon>
                    <h4>Contact Number</h4>
                  </v-col>
                  <v-col cols="5" v-if="viewDetail.contact_number">{{
                    viewDetail.contact_number
                  }}</v-col>
                </v-row>
                <v-row no-gutters class="py-2" v-if="viewDetail.email">
                  <v-col cols="7" class="d-flex align-center">
                    <v-icon class="mr-4 primary--text" small>mdi-email</v-icon>
                    <h4>Email</h4>
                  </v-col>
                  <v-col cols="5" v-if="viewDetail.email">{{
                    viewDetail.email
                  }}</v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="viewDetail && viewDetail.account_manager_companies">
            <ListLayout
              title="Account Manager's Companies"
              :context="context"
              :hasFilter="false"
              :tableData="viewDetail.account_manager_companies"
              :tableHeader="headers"
              :initial-call="false"
            >
            </ListLayout>
          </div>
        </div>
      </template>
    </BaseDetailLayout>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import CompanyStatus from "@/components/AgIcon/CompanyStatus.vue";
import CompanyButton from "@/components/Button/CompanyButton.vue";

export default {
  components: {
    BaseDetailLayout,
    ListLayout,
    CompanyStatus,
    CompanyButton,
  },
  data() {
    return {
      viewDetail: {},
      loading: false,
      headers: [
        {
          headerName: "Company Name",
          field: "name",
          sortable: true,
          pinned: "left",
        },
        {
          headerName: "Contact Number",
          field: "contact_number",
          sortable: true,
        },
        {
          headerName: "Address",
          field: "address",
          sortable: true,
          tooltipField: "address",
        },
        {
          headerName: "Status",
          field: "is_active",
          sortable: true,
          cellRenderer: "CompanyStatus",
        },
        {
          headerName: "Actions",
          field: "actions",
          sortable: false,
          cellRenderer: "CompanyButton",
        },
      ],
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getAccountManagerView(params = {}) {
      bus.$emit("showLoader", true);
      this.loading = true;
      this.$api.accountManager
        .getAccountManagerView(params)
        .then((res) => {
          this.viewDetail = res.data;
          bus.$emit("showLoader", false);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getAccountManagerView(this.$route.params.id);
    }
  },
};
</script>
